import React from 'react';
import { Button } from 'react-admin';
import { l } from '../IdentityShow';
import { KeyIcon } from '~/img';
import { useTranslate } from 'react-admin';

interface Props {
  onClick?: () => void;
  [x: string]: any;
}

const ResetPasswordButton = (props: Props) => {
  const { onClick, ...rest } = props;

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  return (
    <Button label={t('resetPassword')} onClick={onClick} {...rest}>
      <KeyIcon />
    </Button>
  );
};

export default ResetPasswordButton;
